import { NIGHTSHIFT_ORIGIN } from "@/lib/terminal/nightshift-domain"

export const TERMINAL_TITLE = "Night Shift"
// The search description, which Slack also shows under a link's title.
export const TERMINAL_DESCRIPTION =
  "Built for institutions financially exposed to home service contractors."

// The link preview (DESIGN.md › Link preview, 3 November 2026). The card is
// the square stacked lockup without its tagline; the tagline is the title,
// the one line every app shows, and the share description is the search
// description. iMessage plays the square video; X reads its own wide image.
// Every file is served from nightshift.am under TERMINAL_SHARE_PATH, and the
// style page shows the same files.
export const TERMINAL_SHARE_TITLE = "KYB that never sleeps"
export const TERMINAL_SHARE_PATH = "/assets/night-shift/og"
export const TERMINAL_SHARE_FILE_BY_USE = {
  card: { file: "night-shift-og-square.png", width: 1200, height: 1200 },
  cardVideo: { file: "night-shift-og-square.mp4", width: 1080, height: 1080 },
  xCard: { file: "night-shift-og-wide.png", width: 1200, height: 630 },
} as const
const { card, cardVideo, xCard } = TERMINAL_SHARE_FILE_BY_USE
const OG = `${NIGHTSHIFT_ORIGIN}${TERMINAL_SHARE_PATH}`
export const TERMINAL_OG_IMAGE = `${OG}/${card.file}`
export const TERMINAL_OG_VIDEO = `${OG}/${cardVideo.file}`
export const TERMINAL_X_IMAGE = `${OG}/${xCard.file}`

export const getTerminalHeadMeta = (title = TERMINAL_TITLE) => [
  { title },
  { name: "description", content: TERMINAL_DESCRIPTION },
  { property: "og:site_name", content: TERMINAL_TITLE },
  { property: "og:title", content: TERMINAL_SHARE_TITLE },
  // The root route sets WattBot's consumer share description, and a child
  // can only replace a tag, not drop it: so the share description is the
  // search description, the one line already approved for the site.
  { property: "og:description", content: TERMINAL_DESCRIPTION },
  { property: "og:type", content: "website" },
  { property: "og:url", content: NIGHTSHIFT_ORIGIN },
  { property: "og:image", content: TERMINAL_OG_IMAGE },
  { property: "og:image:type", content: "image/png" },
  { property: "og:image:width", content: String(card.width) },
  { property: "og:image:height", content: String(card.height) },
  { property: "og:image:alt", content: TERMINAL_TITLE },
  { property: "og:video", content: TERMINAL_OG_VIDEO },
  { property: "og:video:secure_url", content: TERMINAL_OG_VIDEO },
  { property: "og:video:type", content: "video/mp4" },
  { property: "og:video:width", content: String(cardVideo.width) },
  { property: "og:video:height", content: String(cardVideo.height) },
  { name: "twitter:card", content: "summary_large_image" },
  { name: "twitter:title", content: TERMINAL_SHARE_TITLE },
  { name: "twitter:image", content: TERMINAL_X_IMAGE },
]
